import { ref, computed } from "vue";
import { useApi } from "@/composables/useApi";
import type { PersonnelOption } from "@/types/Personnel";

export function usePersonnelListFull() {
  const { apiDjangoAuth } = useApi();

  const personnels = ref<PersonnelOption[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const personnelsForSelect = computed(() =>
    personnels.value.map((p) => ({
      id: p.id,
      title: `${p.personne.nom} ${p.personne.prenom} (${p.type || p.matricule})`,
      subtitle: p.personne.email,
      value: p.id,
    }))
  );

  async function fetchPersonnels(group?: string | null) {
    loading.value = true;
    error.value = null;

    try {
      let url = "/personnels/non_paginees/";
      if (group) {
        url += `?group=${encodeURIComponent(group)}`;
      }
      
      const response = (await apiDjangoAuth(url)) as any;

      const data = response?.results || response;

      if (Array.isArray(data)) {
        personnels.value = data.map((p: any) => {
          // Extraire le type depuis les groupes si pas déjà présent
          let type = p.type || ''
          if (!type || type.trim() === '') {
            const groups = p.personne?.user?.groups || p.user?.groups || []
            const groupNames = groups.map((g: any) => g.name || g).filter(Boolean)
            if (groupNames.some((name: string) => name === 'Enseignant' || name === 'Enseignement')) {
              type = 'Enseignement'
            } else if (groupNames.some((name: string) => 
              name === 'Administration' || name === 'Admin' || name === 'Administrateur' ||
              name === 'Secrétaire' || name === 'Comptable' || name === 'RH'
            )) {
              type = 'Administration'
            }
          }
          
          return {
            id: p.id,
            matricule: p.matricule || "",
            type: type,
            slug: p.slug || "",
            user: p.personne?.user || p.user || null,
            personne: {
              nom: p.personne?.nom || "",
              prenom: p.personne?.prenom || "",
              email: p.personne?.email || "",
              avatar: p.personne?.avatar || null,
            },
          }
        });
      } else {
        personnels.value = [];
      }
    } catch (err: any) {
      error.value =
        err?.message || "Erreur lors du chargement des personnels";
      personnels.value = [];
    } finally {
      loading.value = false;
    }
  }

  function getPersonnelById(id: number): PersonnelOption | undefined {
    return personnels.value.find((p) => p.id === id);
  }

  return {
    personnels,
    personnelsForSelect,
    loading,
    error,
    fetchPersonnels,
    getPersonnelById,
  };
}


